var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-0"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('indices-data-table',{attrs:{"indices":_vm.indices,"loading":_vm.loading},on:{"rechargeTable":function($event){return _vm.getIndices()}}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }